import { Circle } from 'components'
import * as React from 'react'
import styles from './style.module.scss'

interface IProps {
  active?: boolean
  size?: number
}

export class PopupLoader extends React.PureComponent<IProps> {
  render() {
    const { active } = this.props

    return (
      <React.Fragment>
        {active ? (
          <div className={styles.popup}>
            <Circle />
          </div>
        ) : (
          undefined
        )}
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PopupLoader/index.tsx